import { render, staticRenderFns } from "./checkbox-group.vue?vue&type=template&id=21f3207d"
import script from "./checkbox-group.vue?vue&type=script&lang=ts"
export * from "./checkbox-group.vue?vue&type=script&lang=ts"
import style0 from "./checkbox-group.vue?vue&type=style&index=0&id=21f3207d&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports